// prod mode

export const Server = {
  prod: {
    frontUrl: 'https://app.sytrader.net/',
    baseUrl: 'https://sytrader.net/api-v1/public/api/',
    domaineUrl: 'https://sytrader.net/api-v1/',
    serverFilePath: 'https://sytrader.net/api-v1/storage/app/public/',
    home: '/',
    inscription:
      'https://sytrader.net/account/start-registration/client',
    login: 'https://sytrader.net/account/login',
    cgu: 'https://sytrader.net/cgu',
    paydunia: {
      masterKey: '',
      privateKey: '',
      publicKey: '',
      token: '',
      mode: 'test'
    }
  },
  dev: {
    frontUrl: 'http://localhost:4200/',
    baseUrl: 'http://127.0.0.1:8000/api/',
    domaineUrl: 'http://127.0.0.1:8000/',
    serverFilePath: 'http://127.0.0.1:8000/storage/',
    home: '/',
    inscription:
      'https://plateform.sytrader.net/account/start-registration/client',
    login: 'https://plateform.sytrader.net/account/login',
    cgu: 'info/mentions-legales',
    paydunia: {
      masterKey: '',
      privateKey: '',
      publicKey: '',
      token: '',
      mode: 'live'
    }
  }
};
